/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useInvoiceRebill = (invoiceId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.invoiceRebill(invoiceId),
    mutationFn: ({ paymentMethodId, recurring }) =>
      fetcher({
        method: "PUT",
        url: `/public/invoice/rebill/id/${invoiceId}`,
        data: { payment_method_id: paymentMethodId, recurring },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(invoiceId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.paymentMethods.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.recurringProfiles.all });
    },
  });
};
